export default __webpack_public_path__ + "static/media/po-icon.52a87585.svg";